import { api } from '../index';

// PT-04: opened from the verification email sent to the new address. Public endpoint, no session.
export const confirmEmailChange = async (token) => {
  try {
    const resp = await api.get('/account/confirm-email-change', {
      params: { token },
      withCredentials: false,
    });
    return { success: resp?.data?.code === 0, message: resp?.data?.message };
  } catch (e) {
    return { success: false, message: e?.data?.message || 'Could not confirm the email change. Please try again.' };
  }
};
